import { LMSDataService } from "@/services/lms_data";
import { handle_error } from "@/utils/wretch";
import { json, RouteObject } from "react-router-dom";

const BookingRoute: RouteObject = {
    path: "booking",
    children: [
        {
            path: "reset",
            loader: async () => {
                return null;
            }
        },
        {
            path: "book",
            action: async ({ request }) => {
                const data = await request.json();
                try {
                    const content = await LMSDataService.client.url(`/booking/crm/event_slots/book_v2/`).post(data).json();
                    return json({ success: true, content: content });
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            path: "reschedule/:eventSlotId",
            action: async ({ params, request }) => {
                const data = await request.json();
                try {
                    const content = await LMSDataService.client.url(`/booking/crm/event_slots/${params.eventSlotId}/reschedule/`).post(data).json();
                    return json({ success: true, content: content });
                } catch (error) {
                    return handle_error(error);
                }
            }
        },
        {
            path: ":eventTypeId",
            loader: async ({ params }) => {
                return await LMSDataService.client.url(`/booking/crm/event_types/${params.eventTypeId}/`).get().json();
            },
            children: [
                {
                    path: "hosts",
                    loader: async ({ params }) => {
                        return await LMSDataService.client.url(`/booking/crm/event_types/${params.eventTypeId}/hosts/`).get().json();
                    }
                },
                {
                    path: "calendar",
                    loader: async ({ params, request }) => {
                        const url = new URL(request.url);
                        return await LMSDataService.client
                            .url(`/booking/crm/event_types/${params.eventTypeId}/calendar/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                            .get()
                            .json();
                    }
                },
                {
                    path: "availability",
                    loader: async ({ params, request }) => {
                        const url = new URL(request.url);
                        return await LMSDataService.client
                            .url(`/booking/crm/event_types/${params.eventTypeId}/availability/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
                            .get()
                            .json();
                    }
                }
            ]
        }
    ]
};
export default BookingRoute;
